<form [formGroup]="createForm" (ngSubmit)="onSubmit()">
  <div class="form-group">
    <label>
      {{ 'pairing.username' | translate }}
      <mat-icon matTooltip="{{ 'pairing.create.usernameHelper' | translate }}">
        help_outline
      </mat-icon>
    </label>
    <mat-form-field appearance="outline">
      <input
        matInput
        id="new-username"
        formControlName="username"
        name="username"
        type="text"
        required
      />
      @if (form['username'].errors?.['required']) {
      <mat-error>
        {{ 'pairing.create.error.username.empty' | translate }}
      </mat-error>
      } @if (form['username'].errors?.['minlength']) {
      <mat-error>
        {{ 'pairing.create.error.username.short' | translate }}
      </mat-error>
      } @if (form['username'].errors?.['serverError']) {
      <mat-error>
        {{ 'pairing.create.error.username.alreadyInUse' | translate }}
      </mat-error>
      }
    </mat-form-field>
  </div>
  <div class="form-group">
    <label>{{ 'pairing.email' | translate }}</label>
    <mat-form-field appearance="outline">
      <input
        matInput
        id="email"
        formControlName="email"
        name="email"
        type="text"
        required
      />
      @if (form['email'].errors?.['required']) {
      <mat-error>
        {{ 'pairing.create.error.email.empty' | translate }}
      </mat-error>
      } @if ( form['email'].errors?.['email'] ||
      form['email'].errors?.['serverError'] ) {
      <mat-error>
        {{ 'pairing.create.error.email.format' | translate }}
      </mat-error>
      }
    </mat-form-field>
  </div>
  <div class="form-group">
    <label>
      {{ 'pairing.displayName' | translate }}
      <mat-icon
        matTooltip="{{ 'pairing.create.displayNameHelper' | translate }}"
      >
        help_outline
      </mat-icon>
    </label>
    <mat-form-field appearance="outline">
      <input
        matInput
        id="display-name"
        formControlName="displayName"
        name="displayName"
        type="text"
        required
      />
      @if (form['displayName'].errors?.['required']) {
      <mat-error>
        {{ 'pairing.create.error.displayName.empty' | translate }}
      </mat-error>
      }
    </mat-form-field>
  </div>
  <div class="form-row">
    <div class="form-group">
      <label>{{ 'login.password' | translate }}</label>
      <mat-form-field appearance="outline">
        <input
          matInput
          id="new-password"
          formControlName="password"
          minlength="8"
          name="password"
          [type]="showPassword ? 'text' : 'password'"
          required
        />
        <mat-icon
          matSuffix
          class="material-icons-outlined"
          (click)="showPassword = !showPassword"
        >
          {{ showPassword ? 'visibility_off' : 'visibility' }}
        </mat-icon>
      </mat-form-field>
    </div>
    <div class="form-group">
      <label>{{ 'pairing.confirmPassword' | translate }}</label>
      <mat-form-field appearance="outline">
        <input
          matInput
          id="confirm-password"
          formControlName="confirmPassword"
          minlength="8"
          name="confirmPassword"
          [type]="showConfirmPassword ? 'text' : 'password'"
          required
        />
        <mat-icon
          matSuffix
          class="material-icons-outlined"
          (click)="showConfirmPassword = !showConfirmPassword"
        >
          {{ showConfirmPassword ? 'visibility_off' : 'visibility' }}
        </mat-icon>
      </mat-form-field>
    </div>
  </div>
  <div id="password-errors">
    @if ( form['confirmPassword'].invalid && !wasTouched('confirmPassword') &&
    (form['password'].valid || !wasTouched('password')) ) {
    <mat-hint>{{ 'pairing.passwordHelper' | translate }}</mat-hint>
    } @if (wasTouched('password') && form['password'].errors?.['required']) {
    <mat-error>
      {{ 'pairing.create.error.password.empty' | translate }}
    </mat-error>
    } @if ( form['password'].errors?.['minlength'] ||
    form['password'].errors?.['serverError'] ) {
    <mat-error>
      {{ 'pairing.create.error.password.short' | translate }}
    </mat-error>
    } @if ( form['password'].errors?.['pattern'] ||
    form['password'].errors?.['serverError'] ) {
    <mat-error>
      {{ 'pairing.create.error.password.format' | translate }}
    </mat-error>
    } @if ( wasTouched('confirmPassword') &&
    form['confirmPassword'].errors?.['required'] ) {
    <mat-error>
      {{ 'pairing.create.error.password.notConfirmed' | translate }}
    </mat-error>
    } @if (form['confirmPassword'].errors?.['matching']) {
    <mat-error>
      {{ 'pairing.create.error.password.match' | translate }}
    </mat-error>
    }
  </div>

  <div class="form-group checkbox-group">
    <mat-checkbox
      id="agree-to-terms"
      formControlName="agreeToTerms"
      name="agreeToTerms"
      required
    >
      <span
        [ngClass]="{
          'is-invalid':
            wasTouched('agreeToTerms') && form['agreeToTerms'].errors
        }"
        [innerHTML]="'pairing.agreeToTerms' | translate"
      ></span>
    </mat-checkbox>
    @if ( wasTouched('agreeToTerms') &&
    form['agreeToTerms'].errors?.['required'] ) {
    <mat-error>
      {{ 'pairing.create.error.agreeToTerms.empty' | translate }}
    </mat-error>
    }
  </div>

  <button
    class="submit-button"
    color="primary"
    type="submit"
    mat-flat-button
    [disabled]="!token || createForm.invalid || (isLoading$ | async)"
  >
    {{ 'pairing.create.submitButton' | translate }}
  </button>
</form>
